// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2v0Up","header":"PatientBlock_header__19BHg","label":"PatientBlock_label__HeCCN","option":"PatientBlock_option__25H67"};